import React from "react";
import styles from "../../styles/resumeBuilder.module.css";

const ResumePreview = ({ pdfUrl }) => {
  return (
    <div className={styles.previewContainer}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl + "#view=FitH&toolbar=0"}
          title="Resume Preview"
          width="100%"
          height="100%"
        ></iframe>
      ) : (
        <div className={styles.previewPlaceholder}>
          <p>Your resume preview will appear here.</p>
        </div>
      )}
    </div>
  );
};

export default ResumePreview;
